import {useSelector} from 'react-redux';
import {setErrorCatcher, useViewport, useWindowHeight} from '@treatwell/ui';
import {errorCatcher} from '../../shared/utils/errorCatcher';
import {RouteProvider} from '../components/Router';
import {Title} from '../components/Title';
import styles from './Page.module.css';
import {GenericErrorPage, ReschedulingPeriodOverdueError} from '../Error';
import {store} from '../store';
import {
  selectAppRequestStatus,
  selectShowMultiStaffSelection,
} from '../store/slices/selectors';
import {
  initialise,
  selectRescheduleErrorType,
  selectRescheduleStatus,
} from '../store/slices/reschedule/slice';
import {selectRescheduleDepositFormatted} from '../store/slices/selectors';
import {isRescheduleRoute} from '../utils/isRoute';
import {PageLayout} from './Layout';
import {PAST_RESCHEDULE_DATE} from '../store/slices/constants';
import {useAppSelector} from '../hooks/store';
import {AppContainer} from '../components/App';
import {LoadingSpinner} from '../components/LoadingSpinner';
import {loadGTMLibrary} from '../utils/gtmTracking';

import {STICKY_FOOTER_VIEWPORT_HEIGHT} from '../components/App/App';
import {Tracking} from '../components/Tracking/Tracking';
import {reschedulePageType} from '../utils/generatePageTracking';

if (isRescheduleRoute()) {
  setErrorCatcher({errorCatcher});
  store.dispatch(initialise({url: location.href})).then(() => {
    loadGTMLibrary();
  });
}

export const Reschedule = () => {
  const appStatus = useSelector(selectAppRequestStatus);
  const rescheduleError = useSelector(selectRescheduleErrorType);
  const rescheduledOrderStatus = useAppSelector(selectRescheduleStatus);
  const shouldShowMultiStaffSelection = useAppSelector(
    selectShowMultiStaffSelection,
  );
  const isSmallViewport = useViewport({device: ['mobile', 'tablet']});
  const windowHeight = useWindowHeight();
  const hasDeposit = Boolean(useAppSelector(selectRescheduleDepositFormatted));

  if (appStatus === 'rejected' && rescheduleError === null) {
    return <GenericErrorPage />;
  }

  if (appStatus === 'rejected' && rescheduleError === PAST_RESCHEDULE_DATE) {
    return <ReschedulingPeriodOverdueError />;
  }

  if (appStatus !== 'fulfilled') {
    return (
      <div className={styles.loading}>
        <LoadingSpinner />
      </div>
    );
  }

  if (appStatus === 'fulfilled') {
    const isRescheduledOrderSuccess = rescheduledOrderStatus === 'fulfilled';
    const showFixedFooter =
      (!isRescheduledOrderSuccess && isSmallViewport) ||
      (shouldShowMultiStaffSelection &&
        windowHeight < STICKY_FOOTER_VIEWPORT_HEIGHT);
    return (
      <RouteProvider isRescheduleRoute>
        <Title isReschedule />
        <PageLayout
          showFixedFooter={showFixedFooter && !hasDeposit}
          showFixedFooterDeposits={showFixedFooter && hasDeposit}
          isOnMultiStaffSelection={shouldShowMultiStaffSelection}
        >
          <AppContainer />
          <Tracking pageType={reschedulePageType} />
        </PageLayout>
      </RouteProvider>
    );
  }
  return null;
};
